import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  CheckSquare,
  Wand2,
  KeyRound,
  ScrollText,
  BookOpen,
  Workflow as WorkflowIcon,
} from "lucide-react";
import { WaveGlyph } from "@/components/ui/WaveGlyph";

const items = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, section: "Operate" as const },
  { to: "/approvals", label: "Approvals", icon: CheckSquare, section: "Operate" as const },
  { to: "/workflows", label: "Workflows", icon: WorkflowIcon, section: "Operate" as const },
  { to: "/workflows/new", label: "New workflow", icon: Wand2, section: "Operate" as const },
  { to: "/credentials", label: "Credentials", icon: KeyRound, section: "Admin" as const },
  { to: "/reference-docs", label: "Reference library", icon: BookOpen, section: "Admin" as const },
  { to: "/audit", label: "Audit", icon: ScrollText, section: "Admin" as const },
];

type NavItem = (typeof items)[number];

export function Nav() {
  return (
    <nav
      aria-label="Primary"
      className="flex h-full w-[220px] flex-col border-r border-paper-line bg-paper-0"
    >
      <div className="flex h-[52px] items-center gap-2 px-4">
        <span className="text-teal-500">
          <WaveGlyph size={26} />
        </span>
        <span className="font-serif italic text-xl text-teal-500">Flow</span>
      </div>
      <NavSection title="Operate" items={items.filter((i) => i.section === "Operate")} />
      <NavSection title="Admin" items={items.filter((i) => i.section === "Admin")} />
      <div className="mt-auto border-t border-paper-line p-4">
        <UserTile />
      </div>
    </nav>
  );
}

function NavSection({ title, items }: { title: string; items: NavItem[] }) {
  return (
    <div className="mt-4">
      <div className="px-4 text-xs uppercase tracking-wider text-ink-4">{title}</div>
      <ul className="mt-1">
        {items.map(({ to, label, icon: Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                [
                  "flex items-center gap-2 px-4 py-2 text-sm transition-colors",
                  isActive
                    ? "border-l-2 border-teal-500 bg-paper-tint text-ink-1"
                    : "border-l-2 border-transparent text-ink-2 hover:bg-paper-tint",
                ].join(" ")
              }
            >
              <Icon size={16} aria-hidden />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}

function UserTile() {
  return (
    <div className="flex items-center gap-2">
      <div
        aria-hidden
        className="flex h-8 w-8 items-center justify-center rounded-full bg-teal-500 text-xs font-medium text-paper-3"
      >
        NP
      </div>
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm text-ink-1">Nestor Perez</div>
        <div className="truncate text-xs text-ink-3">IT Director</div>
      </div>
    </div>
  );
}
